import {Component, OnInit} from '@angular/core';
import {availableModels} from "../availableModels";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {LocaleData} from "../model/localeData";
import {Part} from "../model/part";

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  constructor(private translate: TranslateService) {}

  selectedModel!: string;
  selectedYear!: string;

  availableModels = availableModels;
  availableModelYears: string[] = [];
  localeData?: LocaleData;

  filteredParts: Part[] = [];

  ngOnInit() {
    this.updateLocales();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateLocales();
    });
  }

  updateLocales() {
    this.translate
      .get([
        'availableParts',
        'legalNotesLink',
        'dataProtectionLink',
        'contactLink',
      ])
      .subscribe((link: LocaleData) => {
        this.localeData = link;
        this.applyFilters();
      });
  }

  applyModelFilter(selectedValue: any) {
    this.selectedYear = '';
    (document.getElementById('years') as any).selectedIndex = 0;
    if (selectedValue.target.selectedIndex > 0) {
      this.availableModelYears = Object.keys(
        this.availableModels[this.selectedModel]
      );
    }
    this.applyFilters();
  }

  applyFilters() {
    this.filteredParts = [];
    if (this.selectedModel && this.selectedYear) {
      let partKeys: string[] =
        this.availableModels[this.selectedModel][this.selectedYear];
      for (let partKey of partKeys) {
        if (this.localeData?.availableParts[partKey]) {
          console.log(partKey, '111');
          const key = partKey.split(' + ')[0];
          this.filteredParts.push({...this.localeData.availableParts[partKey], partKey: key});
        } else {
          console.error('No Part locales');
        }
      }
    }
    if ((document.getElementById('models') as any).selectedIndex <= 0) {
      (document.getElementById('models') as any).selectedIndex = 0;
      (document.getElementById('years') as any).selectedIndex = 0;
    }
  }

  clearFilters() {
    (document.getElementById('models') as any).selectedIndex = 0;
    (document.getElementById('years') as any).selectedIndex = 0;
    this.selectedModel = '';
    this.selectedYear = '';
    this.filteredParts = [];
  }
  getFileName(year: string) {
    switch (year) {
      case '2025':
        return 'HY';
      default:
        return 'HXHC';
    }
  }
  getTypeName(type: string) {
    switch (type) {
      case 'EUBR':
        return 'CE-EUBR';
      default:
        return 'CE-RED';
    }
  }
  getDocument(name: string, url: string, type: string, year: string): string {
    const fileUrl = `../../assets/pdfs/${this.getFileName(
      year
    )}/${this.getTypeName(type)}/${name}/${url}`;
    // At the moment there is only one set of documents (en).
    //return "../../assets/pdfs/".concat(this.translate.currentLang, "/", s);

    return fileUrl;
  }
}

